import React from 'react'

import Uploader from './Uploader'
import UploadedImages from './UploadedImages'

const ImageUpload = () => {
  return (
    <div className={'upload-container enable'}>
      <Uploader/>
      <UploadedImages />
    </div>
  )
}

export {
  ImageUpload
}
